<template>
	<div class="reset-password" v-if="showError">
		<h2>The link for resetting your password has expired.</h2>
		<button @click="returnToSignIn()">GO BACK TO LOGIN PAGE</button>
	</div>
</template>

<script>
import * as PASSWORD_GENERATION_SERVICE from "@/common/services/password-generation-service";
import {setUser} from "@/common/services/common-request-service";
import {NOTIFICATION_TYPE} from "@/common/utils/constants";

export default {
	name: "ResetPassword",
	data() {
		return {
			showError: false
		}
	},
	mounted() {
		this.encryptData();
		this.$loader.show({
			text: '',
			description: '',
			buttonText: null,
			isBlue: false,
			onCancel: () => {
			}
		});
	},
	methods: {
		encryptData() {
			const password = PASSWORD_GENERATION_SERVICE.decryptUrlSegment(this.$route.params.password);
			const expirationPeriod = PASSWORD_GENERATION_SERVICE.decryptUrlSegment(this.$route.params.expirationPeriod);
			const token = PASSWORD_GENERATION_SERVICE.decryptUrlSegment(this.$route.params.token);


			if (PASSWORD_GENERATION_SERVICE.isNotExpired(expirationPeriod)) {
				this.updatePassword({token, password});
			} else {
				this.showError = true;
			}
		},
		updatePassword(data) {
			setUser(data, "UPDATE")
				.then(() => {
					this.$router.push(`/sign-in`);
				})
				.catch((error) => {
					console.error(error);
					this.showNotification(this.$t('formsNotifications.somethingWentWrong'), NOTIFICATION_TYPE.ERROR);
				})
				.finally(() => this.$loader.hide());
		},
		returnToSignIn() {
			this.$router.push(`/sign-in`)
		},

	}
}
</script>

<style lang="scss" scoped>
@import '@/common/assets/css/_variables.scss';

.reset-password {
	height: 100vh;
	width: 100%;
	background: $drc-dark-blue;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 50px;
	padding-left: 5%;
	padding-right: 5%;

	@media (max-width: $mobile) {
		padding-left: 15px;
		padding-right: 15px;
	}

	h2 {
		margin: 0;
		font-family: Tiempos Headline, serif;
		font-size: 24px;
		font-weight: 500;
		line-height: 34px;
		letter-spacing: 0.360px;
		text-align: left;

		@media (max-width: $tablet) {
			text-align: center;
		}
	}

	button {
		background-color: $color-hover-button;
		min-height: 48px;
		padding: 10px 18px;
		gap: 12px;
		font-family: Roboto, serif;
		font-size: 17px;
		font-weight: 400;
		line-height: 22px;
		text-align: center;
		cursor: pointer;
		margin-top: 20px;
		margin-bottom: 20px;
		border: none;
	}
}
</style>
